import React, { Dispatch, SetStateAction, useState } from "react";

import { DropdownMenu } from "src/app/components/Dropdown/Dropdown";
import { RemoveModal } from "src/app/modals/RemoveModal/RemoveModal";
import { Row } from "src/redux/dictionary/types";
import { GlideDataGridContext } from "../../types";
import MenuItems from "./components/MenuItems";
import { IConfirmationModal } from "./types";

import "./ActionDropdownMenu.scss";

interface ActionDropdownMenuProps {
  context: GlideDataGridContext;
  setIsDropdownOpen: Dispatch<SetStateAction<boolean>>;
  rowData: Row;
}

const initialConfirmationModalSettings = {
  isVisible: false,
  callback: () => {},
};

export function ActionDropdownMenu({
  context,
  setIsDropdownOpen,
  rowData,
}: ActionDropdownMenuProps) {
  const [confirmationModalSettings, setConfirmationModalSettings] =
    useState<IConfirmationModal>(initialConfirmationModalSettings);
  return (
    <>
      <div className="action-dropdown-menu">
        <DropdownMenu>
          <MenuItems
            context={context}
            rowData={rowData}
            setIsDropdownOpen={setIsDropdownOpen}
            setConfirmationModalSettings={setConfirmationModalSettings}
          />
        </DropdownMenu>
      </div>
      {confirmationModalSettings.isVisible && (
        <RemoveModal
          objectNames={[rowData?.title ?? ""]}
          onClose={() => {
            setConfirmationModalSettings(initialConfirmationModalSettings);
            setIsDropdownOpen(false);
          }}
          removeFunction={confirmationModalSettings.callback}
        />
      )}
    </>
  );
}
